import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout';
import { roleGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./auth/login/login').then((m) => m.LoginComponent),
  },
  // the doctor login page was merged into /login; keep old links working
  {
    path: 'doctor-login',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  // {
  //   path: 'doctor-form/:id',
  //   loadComponent: () => import('./layout/pages/doctor-form/doctor-form').then((m) => m.DoctorFormComponent),
  // },
  {
    path: 'doctor-form',
    loadComponent: () =>
      import('./layout/pages/doctor-form/doctor-form').then(
        (m) => m.DoctorFormComponent
      ),
  },
  {
    path: 'doctor-form/:token',
    loadComponent: () =>
      import('./layout/pages/doctor-form/doctor-form').then(
        (m) => m.DoctorFormComponent
      ),
  },
  {
    path: 'Data-backup-policy',
    loadComponent: () => import('./layout/pages/data-backup-policy/data-backup-policy.component').then((m) => m.DataBackupPolicyComponent),
  },
  {
    path: 'Privacy-policy',
    loadComponent: () => import('./layout/pages/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'Privacy-policy-hindi',
    loadComponent: () => import('./layout/pages/hindi-privacy-policy/hindi-privacy-policy.component').then((m) => m.HindiPrivacyPolicyComponent),
  },
   {
    path: 'Data-backup-policy-hindi',
    loadComponent: () => import('./layout/pages/data-backup-policy-hindi/data-backup-policy-hindi.component').then((m) => m.DataBackupPolicyHindiComponent),
  },
    {
    path: 'Term-of-use-hindi',
    loadComponent: () => import('./layout/pages/term-of-use-hindi/term-of-use-hindi.component').then((m) => m.TermOfUseHindiComponent),
  },
  {
    path: 'Terms-and-conditions',
    loadComponent: () => import('./layout/pages/term-of-use/term-of-use.component').then((m) => m.TermOfUseComponent),
  },
  {
    path: 'admin',
    component: LayoutComponent,
    // runs for every admin page (a single guard, so the message shows once)
    canActivateChild: [roleGuard('ADMIN')],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./layout/pages/dashboard/dashboard').then((m) => m.DashboardComponent),
      },
      {
        path: 'doctor-management',
        loadComponent: () => import('./layout/pages/doctor-management/doctor-management').then((m) => m.DoctorManagementComponent),
      },
      {
        path: 'menu-management',
        loadComponent: () => import('./layout/pages/menu-management/menu-management').then((m) => m.MenuManagementComponent),
      },
      {
        path: 'contact',
        loadComponent: () => import('./layout/pages/contacts/contacts').then((m) => m.Contacts),
      },
      {
        path: 'resources',
        loadComponent: () => import('./layout/pages/resources/resources').then((m) => m.ResourcesComponent),
      },
      {
        path: 'resources-summary',
        loadComponent: () => import('./layout/pages/resource-summary/resource-summary.component').then((m) => m.ResourceSummaryComponent),
      },
      {
        path: 'manage-labels',
        loadComponent: () => import('./layout/pages/manage-label/manage-label.component').then((m) => m.ManageLabelComponent),
      },
      {
        path: 'feedback',
        loadComponent: () => import('./layout/pages/feedback/feedback.component').then((m) => m.FeedbackComponent),
      },
      {
        path: 'organization',
        loadComponent: () => import('./layout/pages/organization/organization.component').then((m) => m.OrganizationComponent),
      },
      {
        path: 'lookup',
        loadComponent: () => import('./layout/pages/lookup/lookup.component').then((m) => m.LookupComponent),
      },
      {
        path: 'reports',
        loadComponent: () => import('./layout/pages/reports/reports.component').then((m) => m.ReportsComponent),
      },
        {
        path: 'new-reports',
        loadComponent: () => import('./layout/pages/new-report/new-report.component').then((m) => m.NewReportComponent),
      },
      
        {
        path: 'change-password',
        loadComponent: () => import('./auth/change-password/change-password.component').then((m) => m.ChangePasswordComponent),
      },
      


    ],
  },
    {
    path: 'doctor',
    component: LayoutComponent,
    // runs for every doctor page
    canActivateChild: [roleGuard('DOCTOR')],
    children: [
        {
        path: 'patient-management',
        loadComponent: () => import('./layout/pages/patient/patient.component').then((m) => m.PatientComponent),
      },
      
      {
        path: 'view-patient-data/:id',
        loadComponent: () => import('./layout/pages/patient/view-patient-data/view-patient-data.component').then((m) => m.ViewPatientDataComponent),
      },
      {
        path: 'resource-management',
        loadComponent: () => import('./layout/pages/resource-management/resource-management.component').then((m) => m.ResourceManagementComponent),
      },
      {
        path: 'daily-reports',
        loadComponent: () => import('./layout/pages/doctor-daily-reports/doctor-daily-reports.component').then((m) => m.DoctorDailyReportsComponent),
      }
    ],
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  // any other URL
  {
    path: '**',
    loadComponent: () => import('./layout/pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];


